export const handleValidateObjAssets = (obj) => {
  return Object.keys(obj).filter(k => k !== "photo" && k !== "assetPhoto").every(k => obj[k] !== null && obj[k] !== '');
};
